import { Delegate as Delegate3, PhotoSwipeLightbox, animate as animate7, timeline as timeline5 } from "//www.paulfredrick.com/cdn/shop/t/1001/assets/vendor.min.js?v=52426788336887041471782147360";
import { Drawer, ScrollCarousel, formatMoney } from "//www.paulfredrick.com/cdn/shop/t/1001/assets/theme.js?v=117802595993465950631782205202";


// product-variants.js â€” extracted from theme.js
// Includes: QuickViewDrawer, GiftCardRecipient, ProductLoader, ProductCard,
// ProductForm, BuyButtons, PaymentTerms, PickupAvailability, price/variant elements,
// ProductGallery, ProductZoomButton, ProductQuickAdd, QuickBuyDrawer, VariantPicker

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) =>
  key in obj
    ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value,
      })
    : (obj[key] = value);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
}
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
// js/common/media/image.js
function imageLoaded(imageOrArray) {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === "IMG" && image.complete) ||
          !image.offsetParent
        ) {
          resolve();
        } else {
          image.onload = () => resolve();
        }
      });
    })
  );
}
function generateSrcset(imageObject, widths = []) {
  const imageUrl = new URL(imageObject["src"]);
  return widths
    .filter((width) => width <= imageObject["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
}
function createMediaImg(media, widths = [], properties = {}) {
  const image = new Image(
      media["preview_image"]["width"],
      media["preview_image"]["height"]
    ),
    featuredMediaUrl = new URL(media["preview_image"]["src"]);
  for (const propertyKey in properties) {
    image.setAttribute(propertyKey, properties[propertyKey]);
  }
  image.alt = media["alt"];
  image.src = featuredMediaUrl.href;
  image.srcset = generateSrcset(media["preview_image"], widths);
  return image;
}


var QuickViewDrawer = class extends Drawer {
  constructor() {
    super();
    this.addEventListener("variant:add", this._onVariantAdded.bind(this));
  }

  async show() {
    this.style.display = "block";
    
      [this, ...this.controls].forEach((control) =>
        control.setAttribute("aria-busy", "true")
      );

      const responseContent = await (
        await fetch(
          `${window.Shopify.routes.root}products/${this.getAttribute("handle")}`
        )
      ).text();

      [this, ...this.controls].forEach((control) =>
        control.setAttribute("aria-busy", "false")
      );

      const quickViewContent = new DOMParser()
        .parseFromString(responseContent, "text/html")
        .getElementById("quick-view-content").content;

      Array.from(quickViewContent.querySelectorAll("noscript")).forEach(
        (noScript) => noScript.remove()
      );

      this.replaceChildren(quickViewContent);
      Shopify.PaymentButton?.init();

    return super.show(false);
  }

  async hide() {
    return super.hide()?.then(() => {
      this.style.display = "none";
    });
  }

  _onVariantAdded(event) {
    event.detail.blockCartDrawerOpening = true;
    const contentShadow = this.shadowRoot.querySelector('[part="content"]'),
      fromHeight = contentShadow.clientHeight;

    animate7(
      contentShadow.children,
      { opacity: 0, visibility: "hidden" },
      { duration: 0.15 }
    );

    this.replaceChildren(
      ...new DOMParser()
        .parseFromString(
          event.detail.cart["sections"]["variant-added"],
          "text/html"
        )
        .querySelector(".shopify-section").children
    );

    requestAnimationFrame(async () => {
      await timeline5([
        [
          contentShadow,
          { height: [`${fromHeight}px`, `${contentShadow.clientHeight}px`] },
          { duration: 0.35, easing: [0.86, 0, 0.07, 1] },
        ],
        [
          contentShadow.children,
          { opacity: [0, 1], visibility: "visible" },
          { duration: 0.15 },
        ],
      ]).finished;

      contentShadow.style.height = null;
    });

    this._hasLoaded = false;
  }
};

if (!window.customElements.get("quick-view-drawer")) {
  window.customElements.define("quick-view-drawer", QuickViewDrawer);
}


// js/common/product/gift-card-recipient.js
var _recipientCheckbox,
  _recipientOtherProperties,
  _recipientSendOnProperty,
  _offsetProperty,
  _recipientFieldsContainer,
  _synchronizeProperties,
  synchronizeProperties_fn,
  _formatDate,
  formatDate_fn;
var GiftCardRecipient = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _synchronizeProperties);
    __privateAdd(this, _formatDate);
    __privateAdd(this, _recipientCheckbox, void 0);
    __privateAdd(this, _recipientOtherProperties, []);
    __privateAdd(this, _recipientSendOnProperty, void 0);
    __privateAdd(this, _offsetProperty, void 0);
    __privateAdd(this, _recipientFieldsContainer, void 0);
  }
  connectedCallback() {
    const properties = Array.from(
        this.querySelectorAll('[name*="properties"]')
      ),
      checkboxPropertyName =
        "properties[__shopify_send_gift_card_to_recipient]";
    __privateSet(
      this,
      _recipientCheckbox,
      properties.find((input) => input.name === checkboxPropertyName)
    );
    __privateSet(
      this,
      _recipientOtherProperties,
      properties.filter((input) => input.name !== checkboxPropertyName)
    );
    __privateSet(
      this,
      _recipientFieldsContainer,
      this.querySelector(".gift-card-recipient__fields")
    );
    __privateSet(
      this,
      _offsetProperty,
      this.querySelector('[name="properties[__shopify_offset]"]')
    );
    if (__privateGet(this, _offsetProperty)) {
      __privateGet(this, _offsetProperty).value = /* @__PURE__ */ new Date()
        .getTimezoneOffset()
        .toString();
    }
    __privateSet(
      this,
      _recipientSendOnProperty,
      this.querySelector('[name="properties[Send on]"]')
    );
    const minDate = /* @__PURE__ */ new Date();
    const maxDate = /* @__PURE__ */ new Date();
    maxDate.setDate(minDate.getDate() + 90);
    __privateGet(this, _recipientSendOnProperty)?.setAttribute(
      "min",
      __privateMethod(this, _formatDate, formatDate_fn).call(this, minDate)
    );
    __privateGet(this, _recipientSendOnProperty)?.setAttribute(
      "max",
      __privateMethod(this, _formatDate, formatDate_fn).call(this, maxDate)
    );
    __privateGet(this, _recipientCheckbox)?.addEventListener(
      "change",
      __privateMethod(
        this,
        _synchronizeProperties,
        synchronizeProperties_fn
      ).bind(this)
    );
    __privateMethod(
      this,
      _synchronizeProperties,
      synchronizeProperties_fn
    ).call(this);
  }
};
_recipientCheckbox = new WeakMap();
_recipientOtherProperties = new WeakMap();
_recipientSendOnProperty = new WeakMap();
_offsetProperty = new WeakMap();
_recipientFieldsContainer = new WeakMap();
_synchronizeProperties = new WeakSet();
synchronizeProperties_fn = function () {
  __privateGet(this, _recipientOtherProperties).forEach(
    (property) =>
      (property.disabled = !__privateGet(this, _recipientCheckbox).checked)
  );
  __privateGet(this, _recipientFieldsContainer).classList.toggle(
    "js:hidden",
    !__privateGet(this, _recipientCheckbox).checked
  );
};
_formatDate = new WeakSet();
formatDate_fn = function (date) {
  const offset = date.getTimezoneOffset();
  const offsetDate = new Date(date.getTime() - offset * 60 * 1e3);
  return offsetDate.toISOString().split("T")[0];
};
if (!window.customElements.get("gift-card-recipient")) {
  window.customElements.define("gift-card-recipient", GiftCardRecipient);
}

// js/common/product/product-loader.js
var ProductLoader = class {
  static loadedProducts = {};
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (this.loadedProducts[productHandle]) {
      return this.loadedProducts[productHandle];
    }
    this.loadedProducts[productHandle] = new Promise(
      async (resolve, reject) => {
        const response = await fetch(
          `${Shopify.routes.root}products/${productHandle}.js`
        );
        if (response.ok) {
          const responseAsJson = await response.json();
          resolve(responseAsJson);
        } else {
          reject(`
          Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
        }
      }
    );
    return this.loadedProducts[productHandle];
  }
};

// js/common/product/product-card.js
var ProductCard = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate3(this);
    this.addEventListener(
      "pointerover",
      () => ProductLoader.load(this.getAttribute("handle")),
      { once: true }
    );
  }
  connectedCallback() {
    this._delegate.on(
      "change",
      '[type="radio"]',
      this._onSwatchChanged.bind(this)
    );
    this._delegate.on(
      "pointerover",
      '[type="radio"] + label',
      this._onSwatchHovered.bind(this),
      true
    );
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  async _onSwatchHovered(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target.control),
      primaryMediaElement = this.querySelector(".product-card__image--primary");
    if (
      firstMatchingVariant &&
      firstMatchingVariant.hasOwnProperty("featured_media")
    ) {
      this._createImageElement(
        firstMatchingVariant["featured_media"],
        primaryMediaElement.className,
        primaryMediaElement.sizes
      );
    }
  }
  async _onSwatchChanged(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target);
    this.querySelectorAll(`a[href^="${this.product["url"]}"`).forEach(
      (link) => {
        const url = new URL(link.href);
        url.searchParams.set("variant", firstMatchingVariant["id"]);
        link.href = `${url.pathname}${url.search}${url.hash}`;
      }
    );
    if (!firstMatchingVariant.hasOwnProperty("featured_media")) {
      return;
    }
    const primaryMediaElement = this.querySelector(
        ".product-card__image--primary"
      ),
      secondaryMediaElement = this.querySelector(
        ".product-card__image--secondary"
      );
    const newPrimaryMediaElement = this._createImageElement(
      firstMatchingVariant["featured_media"],
      primaryMediaElement.className,
      primaryMediaElement.sizes
    );
    if (primaryMediaElement.src !== newPrimaryMediaElement.src) {
      secondaryMediaElement
        ? secondaryMediaElement.replaceWith(
            this._createImageElement(
              this.product["media"][
                firstMatchingVariant["featured_media"]["position"]
              ] || this.product["media"][1],
              secondaryMediaElement.className,
              secondaryMediaElement.sizes
            )
          )
        : null;
      await primaryMediaElement.animate(
        { opacity: [1, 0] },
        { duration: 250, easing: "ease-in", fill: "forwards" }
      ).finished;
      await new Promise((resolve) =>
        newPrimaryMediaElement.complete
          ? resolve()
          : (newPrimaryMediaElement.onload = () => resolve())
      );
      primaryMediaElement.replaceWith(newPrimaryMediaElement);
      newPrimaryMediaElement.animate(
        { opacity: [0, 1] },
        { duration: 250, easing: "ease-in" }
      );
    }
  }
  _createImageElement(media, classes, sizes) {
    const previewImage = media["preview_image"],
      image = new Image(previewImage["width"], previewImage["height"]);
    image.className = classes;
    image.alt = media["alt"];
    image.sizes = sizes;
    image.src = previewImage["src"];
    image.srcset = generateSrcset(
      previewImage,
      [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800]
    );
    return image;
  }
  async _getMatchingVariant(target) {
    this.product = await ProductLoader.load(this.getAttribute("handle"));
    return this.product["variants"].find(
      (variant) =>
        variant[
          `option${target
            .closest("[data-option-position]")
            ?.getAttribute("data-option-position")}`
        ] === target.value
    );
  }
};
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}

// js/common/product/product-form.js
var ProductForm = class extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this._onSubmit);
  }
  connectedCallback() {
    this.id.disabled = false;
  }
  async _onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }

    const submitButtons = Array.from(this.elements).filter(
      (button) => button.type === "submit"
    );
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set(
      "sections_url",
      `${Shopify.routes.root}variants/${this.id.value}`
    );

    const parent = event?.target?.closest('.product-info-reference');

    const numberPrev = formData.get('id');
    // const timestamp = numberPrev.toString().slice(-3)
    const timestamp = Date.now().toString(36) + Math.random().toString(36).substring(2)

    const monogram = parent ? parent.querySelector("#monogram") : document.querySelector("#monogram");

    const setProperties = ({type}) => {
      const element = parent.querySelector(`#${type}`)
      if (!element) return;
    
      const properties = element.getProperties();
    
      if (!properties || Object.keys(properties).length === 0) {
        return;
      }
      
      for (const key in properties) {
        const value = properties[key];
        if(key == 'undefined' || key == undefined || value == 'undefined' || value == '') return
        formData.set(`properties[${key}]`, value);
      }
    };
    
    if(!!parent){
      setProperties({
        type: 'monogram'
      });
  
      setProperties({
        type: 'engraving'
      });
  
      setProperties({
        type: 'alterations'
      });
    }
    

    const backorderPropertie = document.querySelector(
      'input[name="properties[backorder]"]'
    );
    
    if (backorderPropertie) {
      formData.set(`properties[backorder]`, backorderPropertie.value);
    }

    if(formData.has('properties[Color]') || 
      formData.has('properties[color]') || 
      formData.has('properties[Select Inseam]') || 
      formData.has('properties[Your Initials]')) {
      formData.set(`properties[_group_id]`, timestamp)
      formData.set(`properties[_return]`, "No")
    }

    const isFinalSale = this.closest('.product-info-reference').querySelector('input[name="properties[final_sale]"]');

    if(isFinalSale) {
      formData.set(`properties[final_sale]`, isFinalSale.value);
    }

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        // Needed for Shopify to check inventory
      },
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });

    const responseJson = await response.json();
    const typeComplementary = formData.has('properties[color]') && formData.has('properties[initials]') 
      ? 'monogram'
      : formData.has('properties[Your Initials]') 
        ? 'engraving'
      : formData.has('properties[Select Inseam]') 
        ? 'alteration'
      : 'default';

    
    const referenceId = timestamp;

    if (monogram && response.ok && typeComplementary == 'monogram') {

      // await monogram.updateCurrentProduct({
      //   key: timestamp,
      //   properties: responseJson['properties'],
      //   quantity: formData.get('quantity') || 1
      // })
      
      await monogram.updateAndAddMonogramToCart({
        key: timestamp,
        properties: responseJson['properties']
      });
    }

    if(response.ok && typeComplementary == 'alteration') {
      const alteration =  this.closest('.product-info-reference').querySelector('checkbox-options');

      // await alteration.updateCurrentProduct({
      //   key: timestamp,
      //   properties: responseJson['properties'],
      //   quantity: formData.get('quantity') || 1
      // })
      
      await alteration.addProductReference({
        key: timestamp,
        quantity: formData.get('quantity') || 1
      });
    }

    if(response.ok && typeComplementary == 'engraving') {
      
      responseJson['properties']['Return'] = "No"
      
      const engraving =  this.closest('.product-info-reference').querySelector('checkbox-options');
      // await engraving.updateCurrentProduct({
      //   key: timestamp,
      //   properties: responseJson['properties'],
      //   quantity: formData.get('quantity') || 1
      // })
      
      await engraving.addProductReference({
        key: timestamp,
        quantity: formData.get('quantity') || 1
      });
    }

    const quickViewContainer = this.closest(".drawer-quick-view");

    if (!!quickViewContainer && response.ok) {

      quickViewContainer.querySelector('button[is="close-button"]').click()

      const footerQuickView = quickViewContainer.querySelector('.drawer-footer');
      const notificationQuickView = quickViewContainer.querySelector('.notification');
      
      quickViewContainer.classList.add('drawer-quick-view--submit-hide');
      footerQuickView.classList.remove('hidden');
      notificationQuickView.innerHTML = `Added to your cart!`

    }

    if (response.ok) {
      if (
        window.themeVariables.settings.cartType === "page" ||
        window.themeVariables.settings.pageType === "cart"
      ) {
        return (window.location.href = `${Shopify.routes.root}cart`);
      }
      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart.js`)
      ).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items")
              ? responseJson["items"]
              : [responseJson],
            cart: cartContent,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent,
          },
        })
      );

      ltkCartUpdate();
      window.runCartCleanupAndRefreshDebounced();
      
    } else {
      this.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"],
          },
        })
      );
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }
};
if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm, {
    extends: "form",
  });
}

// js/common/product/product-form-listeners.js
var BuyButtons = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._onCartErrorListener = this._onCartError.bind(this);
  }
  connectedCallback() {
    this._productForm = document.forms[this.getAttribute("form")];
    this._productForm?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
    this._productForm?.addEventListener(
      "cart:error",
      this._onCartErrorListener
    );
  }
  disconnectedCallback() {
    this._productForm?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
    this._productForm?.removeEventListener(
      "cart:error",
      this._onCartErrorListener
    );
  }
  _onVariantChanged(event) {
    const addToCartButton = this.querySelector('button[type="submit"]'),
      paymentButton = this.querySelector(".shopify-payment-button");
    addToCartButton.classList.remove("button--secondary", "button--subdued");
    addToCartButton.disabled =
      !event.detail.variant || !event.detail.variant["available"];
    const addToCartButtonText =
      addToCartButton.getAttribute("is") === "custom-button"
        ? addToCartButton.firstElementChild
        : addToCartButton;
    if (!event.detail.variant) {
      addToCartButtonText.innerHTML =
        window.themeVariables.strings.unavailableButton;
      addToCartButton.classList.add("button--subdued");
      if (paymentButton) {
        paymentButton.style.display = "none";
      }
    } else {
      addToCartButton.classList.add(
        event.detail.variant["available"]
          ? paymentButton || this.hasAttribute("force-secondary-button")
            ? "button--secondary"
            : "button"
          : "button--subdued"
      );
      addToCartButtonText.innerHTML = event.detail.variant["available"]
        ? this.getAttribute("template").includes("pre-order")
          ? window.themeVariables.strings.preOrderButton
          : window.themeVariables.strings.addToCartButton
        : window.themeVariables.strings.soldOutButton;
      if (paymentButton) {
        paymentButton.style.display = event.detail.variant["available"]
          ? "block"
          : "none";
      }
    }
  }
  _onCartError(event) {
    const errorBanner = document.createElement("div");
    errorBanner.classList.add("banner", "banner--error", "justify-center");
    errorBanner.setAttribute("role", "alert");
    errorBanner.style.gridColumn = "1/-1";
    errorBanner.style.marginBottom = "1rem";
    errorBanner.innerHTML = `
      <svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
        <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
      </svg>
      
      <p>${event.detail.error}</p>
    `;
    this.before(errorBanner);
    setTimeout(async () => {
      await errorBanner.animate(
        { opacity: [1, 0] },
        { duration: 250, fill: "forwards" }
      ).finished;
      errorBanner.remove();
    }, 5e3);
  }
};
if (!window.customElements.get("buy-buttons")) {
  window.customElements.define("buy-buttons", BuyButtons);
}
var PaymentTerms = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  _onVariantChanged(event) {
    if (event.detail.variant) {
      const element = this.querySelector('[name="id"]');
      element.value = event.detail.variant["id"];
      element.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};
if (!window.customElements.get("payment-terms")) {
  window.customElements.define("payment-terms", PaymentTerms);
}
var PickupAvailability = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  async _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      const element = document.createElement("div");
      element.innerHTML = await (
        await fetch(
          `${Shopify.routes.root}variants/${event.detail.variant["id"]}?section_id=pickup-availability`
        )
      ).text();
      this.replaceChildren(
        ...element.querySelector("pickup-availability").childNodes
      );
    }
  }
};
if (!window.customElements.get("pickup-availability")) {
  window.customElements.define("pickup-availability", PickupAvailability);
}
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
  ? window.themeVariables.settings.moneyWithCurrencyFormat
  : window.themeVariables.settings.moneyFormat;
var SalePrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.lastChild.replaceWith(
      document
        .createRange()
        .createContextualFragment(formatMoney(variant["price"], currencyFormat))
    );
    this.classList.toggle(
      "text-on-sale",
      variant["compare_at_price"] > variant["price"]
    );
  }
};
var CompareAtPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.lastChild.replaceWith(
      document
        .createRange()
        .createContextualFragment(
          formatMoney(variant["compare_at_price"], currencyFormat)
        )
    );
    this.hidden = !(variant["compare_at_price"] > variant["price"]);
  }
};
var UnitPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant["unit_price"]) {
      return (this.hidden = true);
    }
    const referenceValue =
      variant["unit_price_measurement"]["reference_value"] !== 1
        ? variant["unit_price_measurement"]["reference_value"]
        : "";
    const node = document
      .createRange()
      .createContextualFragment(
        `${formatMoney(variant["unit_price"])}/${referenceValue}${
          variant["unit_price_measurement"]["reference_unit"]
        }`
      );
    this.lastChild.replaceWith(node);
    this.hidden = false;
  }
};
if (!window.customElements.get("sale-price")) {
  window.customElements.define("sale-price", SalePrice);
}
if (!window.customElements.get("compare-at-price")) {
  window.customElements.define("compare-at-price", CompareAtPrice);
}
if (!window.customElements.get("unit-price")) {
  window.customElements.define("unit-price", UnitPrice);
}
var _onVariantChanged, onVariantChanged_fn;
var SoldOutBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged);
    __publicField(
      this,
      "_onVariantChangedListener",
      __privateMethod(this, _onVariantChanged, onVariantChanged_fn).bind(this)
    );
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
};
_onVariantChanged = new WeakSet();
onVariantChanged_fn = function (event) {
  this.hidden = event.detail.variant["available"];
};
var _onVariantChanged2, onVariantChanged_fn2;
var OnSaleBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged2);
    __publicField(
      this,
      "_onVariantChangedListener",
      __privateMethod(this, _onVariantChanged2, onVariantChanged_fn2).bind(this)
    );
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
};
_onVariantChanged2 = new WeakSet();
onVariantChanged_fn2 = function (event) {
  const variant = event.detail.variant;
  if (variant["compare_at_price"] > variant["price"]) {
    this.hidden = false;
    if (this.hasAttribute("discount-mode")) {
      const savings =
        this.getAttribute("discount-mode") === "percentage"
          ? `${Math.round(
              ((variant["compare_at_price"] - variant["price"]) * 100) /
                variant["compare_at_price"]
            )}%`
          : formatMoney(variant["compare_at_price"] - variant["price"]);
      this.innerHTML = `${window.themeVariables.strings.discountBadge.replace(
        "@@",
        savings
      )}`;
    }
  } else {
    this.hidden = true;
  }
};
if (!window.customElements.get("sold-out-badge")) {
  window.customElements.define("sold-out-badge", SoldOutBadge);
}
if (!window.customElements.get("on-sale-badge")) {
  window.customElements.define("on-sale-badge", OnSaleBadge);
}
var VariantInventory = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  _onVariantChanged(event) {
  console.log("variant changed")
    const variantId = event.detail.variant ? event.detail.variant["id"] : null;
    Array.from(this.children).forEach((item) =>
      item.toggleAttribute(
        "hidden",
        variantId !== parseInt(item.getAttribute("data-variant-id"))
      )
    );
  }
};
if (!window.customElements.get("variant-inventory")) {
  window.customElements.define("variant-inventory", VariantInventory);
}
var VariantMedia = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    this.sizesAttribute = this.querySelector("img").sizes;
    this.classAttribute = this.querySelector("img").className;
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  get widths() {
    return this.getAttribute("widths")
      .split(",")
      .map((width) => parseInt(width));
  }
  _onVariantChanged(event) {
    if (!event.detail.variant || !event.detail.variant["featured_media"]) {
      return;
    }
    this.replaceChildren(
      createMediaImg(event.detail.variant["featured_media"], this.widths, {
        class: this.classAttribute,
        sizes: this.sizesAttribute,
      })
    );
  }
};
if (!window.customElements.get("variant-media")) {
  window.customElements.define("variant-media", VariantMedia);
}
var VariantSku = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.hidden = true;
    } else {
      this.innerText = `${window.themeVariables.strings.sku} ${event.detail.variant["sku"]}`;
      this.hidden = !event.detail.variant["sku"];
    }
  }
};
if (!window.customElements.get("variant-sku")) {
  window.customElements.define("variant-sku", VariantSku);
}

// js/common/product/product-gallery.js
var ProductGallery = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
    this._carousels = Array.from(this.querySelectorAll("media-carousel"));
    this._pageDots = Array.from(this.querySelectorAll("page-dots"));
    this._viewInSpaceButton = this.querySelector("[data-shopify-xr]");
    this._customCursor = this.querySelector(".product-gallery__cursor");
    this.addEventListener("carousel:change", this._onCarouselChanged);
    if (this._viewInSpaceButton) {
      this.addEventListener("carousel:settle", this._updateViewInSpaceButton);
    }
    if (this.hasAttribute("allow-zoom")) {
      this.addEventListener("lightbox:open", (event) =>
        this.openZoom(event.detail.index)
      );
    }
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  get photoswipe() {
    if (this._photoswipe) {
      return this._photoswipe;
    }
    const photoswipe = new PhotoSwipeLightbox({
      pswpModule: () => import("//www.paulfredrick.com/cdn/shop/t/1001/assets/photoswipe.min.js?v=20290624223189769891782147360"),
      bgOpacity: 1,
      maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      // UX
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      zoom: false,
      closeSVG: `<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
<circle cx="30" cy="30" r="29.5" fill="white" stroke="#1E1E1E"/>
<g clip-path="url(#clip0_5988_26658)">
<rect width="24" height="24" transform="translate(18 18)" fill="white"/>
<path d="M22.5449 37.4551L37.456 22.544" stroke="#1E1E1E" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.5449 22.5449L37.456 37.456" stroke="#1E1E1E" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_5988_26658">
<rect width="24" height="24" fill="white" transform="translate(18 18)"/>
</clipPath>
</defs>
</svg>`,
    });
    photoswipe.addFilter(
      "thumbEl",
      (thumbEl, data) => data["thumbnailElement"]
    );
    photoswipe.on("uiRegister", () => {
      photoswipe.pswp.ui.registerElement({
        name: "bottom-bar",
        order: 5,
        appendTo: "wrapper",
        onInit: (el, pswp) => {
          // Base container
          el.classList.add("pswp__thumbstrip-wrap", "pswp__hide-on-close");

          // Left arrow
          const prevBtn = document.createElement("button");
          prevBtn.type = "button";
          prevBtn.className = "pswp__navbtn pswp__navbtn--prev";
          prevBtn.setAttribute("aria-label", "Previous image");
          prevBtn.addEventListener("click", () => pswp.prev());
          prevBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<foreignObject x="-20" y="-20" width="80" height="80"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(10px);clip-path:url(#bgblur_0_5998_2340_clip_path);height:100%;width:100%"></div></foreignObject><circle data-figma-bg-blur-radius="20" cx="20" cy="20" r="20" fill="white" fill-opacity="0.7"/>
<path d="M22.7684 27.7493L15.3838 20.3648C15.182 20.1632 15.182 19.8361 15.3838 19.6346L22.7684 12.25" stroke="#1E1E1E" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round"/>
<defs>
<clipPath id="bgblur_0_5998_2340_clip_path" transform="translate(20 20)"><circle cx="20" cy="20" r="20"/>
</clipPath></defs>
</svg>`;
          el.appendChild(prevBtn);

          // Thumbstrip (scrollable)
          const strip = document.createElement("div");
          strip.className = "pswp__thumbstrip";
          el.appendChild(strip);

          // Right arrow
          const nextBtn = document.createElement("button");
          nextBtn.type = "button";
          nextBtn.className = "pswp__navbtn pswp__navbtn--next";
          nextBtn.setAttribute("aria-label", "Next image");
          nextBtn.addEventListener("click", () => pswp.next());
          nextBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<foreignObject x="-20" y="-20" width="80" height="80"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(10px);clip-path:url(#bgblur_0_5998_2337_clip_path);height:100%;width:100%"></div></foreignObject><circle data-figma-bg-blur-radius="20" cx="20" cy="20" r="20" fill="white" fill-opacity="0.7"/>
<path d="M17.2324 12.6758L24.617 20.0603C24.8189 20.2619 24.8189 20.589 24.617 20.7905L17.2324 28.1751" stroke="#1E1E1E" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round"/>
<defs>
<clipPath id="bgblur_0_5998_2337_clip_path" transform="translate(20 20)"><circle cx="20" cy="20" r="20"/>
</clipPath></defs>
</svg>`;
          el.appendChild(nextBtn);

          // Build thumb buttons
          const buttons = [];
          for (let i = 0; i < pswp.getNumItems(); i++) {
            const item = pswp.getItemData(i);

            const domImg =
              item.element?.querySelector?.("img") || item.thumbnailElement || null;
            const thumbSrc =
              item.msrc || domImg?.currentSrc || domImg?.src || item.src;

            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "pswp__thumbstrip-btn";
            btn.addEventListener("click", () => pswp.goTo(i));

            const img = document.createElement("img");
            img.className = "pswp__thumbstrip-img";
            img.src = thumbSrc;
            img.alt = item.alt || "";
            btn.appendChild(img);

            strip.appendChild(btn);
            buttons.push(btn);
          }

          const updateArrows = () => {
            if (pswp.options.loop) {
              prevBtn.disabled = false;
              nextBtn.disabled = false;
              return;
            }
            prevBtn.disabled = pswp.currIndex <= 0;
            nextBtn.disabled = pswp.currIndex >= pswp.getNumItems() - 1;
          };

          const setActive = () => {
            buttons.forEach((b, idx) =>
              b.classList.toggle("is-active", idx === pswp.currIndex)
            );
            const active = buttons[pswp.currIndex];
            if (active) active.scrollIntoView({ inline: "nearest", block: "nearest" });
            updateArrows();
          };

          pswp.on("openingAnimationEnd", setActive);
          pswp.on("change", setActive);
        },
      });
    });
    photoswipe.init();
    return (this._photoswipe = photoswipe);
  }
  /**
   * Open the zoom by dynamically creating a data source based on the filtered items
   */
  openZoom(index = 0) {
    const dataSource = Array.from(
      this.querySelectorAll(
        '.product-gallery__media[data-media-type="image"]:not([hidden]) > img'
      )
    ).map((image) => {
      return {
        thumbnailElement: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt: image.alt,
        thumbCropped: true,
      };
    });
    this.photoswipe.loadAndOpen(index, dataSource);
  }
  _updateViewInSpaceButton(event) {
    if (event.detail.slide.getAttribute("data-media-type") === "model") {
      this._viewInSpaceButton.setAttribute(
        "data-shopify-model3d-id",
        event.detail.slide.getAttribute("data-media-id")
      );
    } else {
      this._viewInSpaceButton.setAttribute(
        "data-shopify-model3d-id",
        this._viewInSpaceButton.getAttribute("data-shopify-model3d-default-id")
      );
    }
  }
  _onCarouselChanged(event) {
    if (this._customCursor) {
      this._customCursor.toggleAttribute(
        "hidden",
        event.detail.slide.getAttribute("data-media-type") !== "image"
      );
    }
  }
  _onVariantChanged(event) {
    const filteredIndexes = this._getFilteredMediaIndexes(
      event.detail.product,
      event.detail.variant
    );
    this._carousels.forEach((carousel) =>
      carousel.dispatchEvent(
        new CustomEvent("carousel:filter", { detail: { filteredIndexes } })
      )
    );
    this._pageDots.forEach((pageDots) =>
      pageDots.dispatchEvent(
        new CustomEvent("control:filter", { detail: { filteredIndexes } })
      )
    );
    if (
      (event.detail.variant["featured_media"] &&
        event.detail.previousVariant["featured_media"] &&
        event.detail.previousVariant["featured_media"]["id"] !==
          event.detail.variant["featured_media"]["id"]) ||
      (!event.detail.previousVariant["featured_media"] &&
        event.detail.variant["featured_media"])
    ) {
      this._carousels.forEach((carousel) =>
        carousel.select(
          event.detail.variant["featured_media"]["position"] - 1,
          { animate: false }
        )
      );
    }
  }
  _getFilteredMediaIndexes(product, variant) {
    const filteredMediaIds = [];
    product["media"].forEach((media) => {
      let matchMedia =
        variant["featured_media"] &&
        media["position"] === variant["featured_media"]["position"];
      if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
        if (!matchMedia) {
          const altParts = media["alt"].split("#"),
            mediaGroupParts = altParts.pop().split("_");
          product["options"].forEach((option) => {
            if (
              option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()
            ) {
              if (
                variant["options"][option["position"] - 1].toLowerCase() !==
                mediaGroupParts[1].trim().toLowerCase()
              ) {
                filteredMediaIds.push(media["position"] - 1);
              }
            }
          });
        }
      }
    });
    return filteredMediaIds;
  }
};
var MediaCarousel = class extends ScrollCarousel {
  connectedCallback() {
    super.connectedCallback();
    this._onGestureChangedListener = this._onGestureChanged.bind(this);
    this.addEventListener("gesturestart", this._onGestureStart, {
      capture: false,
      signal: this._abortController.signal,
    });
    this.addEventListener("carousel:settle", this._onMediaSettled, {
      signal: this._abortController.signal,
    });
    this.addEventListener("click", this._onGalleryClick);
  }
  _onMediaSettled(event) {
    const media = event.detail.slide;
    this.items
      .filter((item) =>
        ["video", "external_video", "model"].includes(
          item.getAttribute("data-media-type")
        )
      )
      .forEach((item) => item.firstElementChild.pause());
    switch (media.getAttribute("data-media-type")) {
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay")) {
          media.firstElementChild.play();
        }
        break;
      case "model":
        if (window.matchMedia("(min-width: 1000px)").matches) {
          media.firstElementChild.play();
        }
        break;
    }
  }
  _onGalleryClick(event) {
    if (
      event.target.matches("button, a[href], button :scope, a[href] :scope") ||
      !window.matchMedia("screen and (pointer: fine)").matches
    ) {
      return;
    }
    if (this.selectedSlide.getAttribute("data-media-type") !== "image") {
      return;
    }
    const rect = event.currentTarget.getBoundingClientRect(),
      offsetX = event.clientX - rect.left;
    offsetX > this.clientWidth / 2 ? this.next() : this.previous();
  }
  _onGestureStart(event) {
    event.preventDefault();
    this.addEventListener("gesturechange", this._onGestureChangedListener, {
      capture: false,
      signal: this._abortController.signal,
    });
  }
  _onGestureChanged(event) {
    event.preventDefault();
    if (event.scale > 1.5) {
      const visibleImages = this.visibleItems.filter(
          (item) => item.getAttribute("data-media-type") === "image"
        ),
        openIndex = visibleImages.indexOf(this.selectedSlide);
      this.dispatchEvent(
        new CustomEvent("lightbox:open", {
          bubbles: true,
          detail: { index: openIndex },
        })
      );
      this.removeEventListener("gesturechange", this._onGestureChangedListener);
    }
  }
};
var ProductZoomButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._onButtonClicked);
  }
  _onButtonClicked() {
    let media = this.closest(".product-gallery__media"),
      openIndex;
    if (media) {
      const visibleImages = this.closest("media-carousel").visibleItems.filter(
        (item) => item.getAttribute("data-media-type") === "image"
      );
      openIndex = visibleImages.indexOf(media);
    } else {
      const carousel = this.closest(
          ".product-gallery__media-list-wrapper"
        ).querySelector("media-carousel"),
        visibleImages = carousel.visibleItems.filter(
          (item) => item.getAttribute("data-media-type") === "image"
        );
      openIndex = visibleImages.indexOf(carousel.selectedSlide);
    }
    this.dispatchEvent(
      new CustomEvent("lightbox:open", {
        bubbles: true,
        detail: {
          index: openIndex,
        },
      })
    );
  }
};
if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}
if (!window.customElements.get("product-zoom-button")) {
  window.customElements.define("product-zoom-button", ProductZoomButton, {
    extends: "button",
  });
}
if (!window.customElements.get("media-carousel")) {
  window.customElements.define("media-carousel", MediaCarousel);
}

// js/common/product/quick-add.js
var ProductQuickAdd = class extends HTMLElement {
  #scopeFromPassed = false;
  #scopeToReached = false;
  #intersectionObserver = new IntersectionObserver(this._onObserved.bind(this));
  connectedCallback() {
    this._scopeFrom = document.querySelector(".product-info__quantity-selector quantity-selector")
    this._scopeTo = document.querySelector(".footer");
    if (!this._scopeFrom || !this._scopeTo) {
      return;
    }
    this.#intersectionObserver.observe(this._scopeFrom);
    this.#intersectionObserver.observe(this._scopeTo);
  }
  disconnectedCallback() {
    this.#intersectionObserver.disconnect();
  }
  _onObserved(entries) {
    entries.forEach((entry) => {
      console.log(entry)
      if (entry.target === this._scopeFrom) {
        this.#scopeFromPassed = entry.boundingClientRect.bottom < 0;
      }
      if (entry.target === this._scopeTo) {
        this.#scopeToReached = entry.isIntersecting;
      }
    });
    this.classList.toggle(
      "is-visible",
      this.#scopeFromPassed && !this.#scopeToReached
    );
  }
};
if (!window.customElements.get("product-quick-add")) {
  window.customElements.define("product-quick-add", ProductQuickAdd);
}

// js/common/product/quick-buy-drawer.js
var QuickBuyDrawer = class extends Drawer {
  constructor() {
    super();
    this._hasLoaded = false;
    this.addEventListener("variant:add", this._onVariantAdded.bind(this));
  }
  async show() {
    this.style.display = "block";
    if (!this._hasLoaded) {
      [this, ...this.controls].forEach((control) =>
        control.setAttribute("aria-busy", "true")
      );
      const responseContent = await (
        await fetch(
          `${window.Shopify.routes.root}products/${this.getAttribute("handle")}`
        )
      ).text();
      [this, ...this.controls].forEach((control) =>
        control.setAttribute("aria-busy", "false")
      );
      const quickBuyContent = new DOMParser()
        .parseFromString(responseContent, "text/html")
        .getElementById("quick-buy-content").content;
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach(
        (noScript) => noScript.remove()
      );
      this.replaceChildren(quickBuyContent);
      Shopify.PaymentButton?.init();
      this._hasLoaded = true;
    }
    return super.show();
  }
  async hide() {
    return super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded(event) {
    event.detail.blockCartDrawerOpening = true;
    const contentShadow = this.shadowRoot.querySelector('[part="content"]'),
      fromHeight = contentShadow.clientHeight;
    animate7(
      contentShadow.children,
      { opacity: 0, visibility: "hidden" },
      { duration: 0.15 }
    );
    this.replaceChildren(
      ...new DOMParser()
        .parseFromString(
          event.detail.cart["sections"]["variant-added"],
          "text/html"
        )
        .querySelector(".shopify-section").children
    );
    requestAnimationFrame(async () => {
      await timeline5([
        [
          contentShadow,
          { height: [`${fromHeight}px`, `${contentShadow.clientHeight}px`] },
          { duration: 0.35, easing: [0.86, 0, 0.07, 1] },
        ],
        [
          contentShadow.children,
          { opacity: [0, 1], visibility: "visible" },
          { duration: 0.15 },
        ],
      ]).finished;
      contentShadow.style.height = null;
    });
    this._hasLoaded = false;
  }
};
if (!window.customElements.get("quick-buy-drawer")) {
  window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
}

// js/common/product/variant-picker.js
var VariantPicker = class extends HTMLElement {
  async connectedCallback() {
    this._abortController = new AbortController();
    this.masterSelector = document.forms[this.getAttribute("form")].id;
    this.optionSelectors = Array.from(
      this.querySelectorAll("[data-option-selector]")
    );
    if (!this.masterSelector) {
      console.warn(
        `The variant selector for product with handle ${this.productHandle} is not linked to any product form.`
      );
      return;
    }
    this.product = await ProductLoader.load(this.productHandle);
    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener(
        "change",
        this._onOptionChanged.bind(this),
        { signal: this._abortController.signal }
      );
    });
    this.masterSelector.addEventListener(
      "change",
      this._onMasterSelectorChanged.bind(this),
      { signal: this._abortController.signal }
    );
    this._updateDisableSelectors();
    if (this.selectedVariant) {
    this.selectVariant(this.selectedVariant["id"]);
    new BackorderProduct(this.selectedVariant["id"])
    }

  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get selectedVariant() {
    return this._getVariantById(parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  /**
   * Select a new variant by its ID
   */
  selectVariant(id) {

    if (!this._isVariantSelectable(this._getVariantById(id))) {
      id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
    }
    const previousVariant = this.selectedVariant;
    // if (previousVariant && previousVariant.id === id) {
    //   return;
    // }

    if(this.masterSelector){
      this.masterSelector.value = id;
      this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    }

    this._updateDisableSelectors();
    
    // Unless all selections have been made stop URL + Form activation
    let noSelect = document.querySelectorAll(".product-info__variant-picker .no-select") 

    console.log("changed")

    if (noSelect.length > 0) {
      
      let checkValue = event.target.value.toLowerCase()
      
      if ( checkValue == "pleated front" || checkValue == "flat front") {
        console.log(checkValue)
        document.querySelectorAll(".product-gallery__media").forEach((media) => {

          console.log(media)
          console.log(media.alt)

          let altText = media.querySelector("img").alt

          if (!altText.includes(checkValue)) {
            media.setAttribute("hidden", "")
          } else {
            media.removeAttribute("hidden")
          } 
        
        })
      }
      
        return
      }

    if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState(
        { path: newUrl.toString() },
        "",
        newUrl.toString()
      );
    }


    this.masterSelector.form.dispatchEvent(
      new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          product: this.product,
          variant: this.selectedVariant,
          previousVariant,
        },
      })
    );

    fetch(`${window.location.href}&section_id=api-quantity-selector`)
    .then((response) => {
        return response.text()
        })
        .then((response) => {
        
        const html = new DOMParser().parseFromString(response, 'text/html');
        let maxInput = document.querySelector(".product-info__quantity-selector quantity-selector input")

        if (maxInput) {
          document.querySelector(".product-info__quantity-selector quantity-selector input").max = html.querySelector("quantity-selector input").max
        }
      })

    // HERE
  let thisTitle = this.selectedVariant.public_title

  document.querySelectorAll("[id*=color-swatch-json-]").forEach((script) => {

    let json = JSON.parse(script.innerText)

    let available = false
    json.forEach((v) => {
      if (thisTitle == v.title) {
        available = v.available
      }
    })

    if (!available) {
      script.parentElement.querySelector(".color-swatch-line").classList.remove("hidden")
    } else {
      script.parentElement.querySelector(".color-swatch-line").classList.add("hidden")
    }

  })

    const infoText = document.querySelector('.drawer-container .variant_title')
    if(infoText && this.selectedVariant){
      infoText.innerHTML = this.selectedVariant["title"]
    }

    new BackorderProduct(id)
  }
  _onOptionChanged(event) {

    event.target.closest(".no-select")?.classList.remove("no-select")

    let noSelectSize = document.querySelectorAll(".no-select").length

    let testFit = document.querySelector(".variant-picker__fit:has(.no-select)")
    console.log("TEST FIT: ", testFit)

    if(!testFit) {
      let wlContainer = document.querySelector(".atc-wl-container .button div")

      if(wlContainer) {
        document.querySelector(".atc-wl-container .button div").innerText = "Select a Size"
      }
    }

    if (!event.target.name.startsWith("option")) {
      return;
    }

    if (noSelectSize > 1) return

    console.log("SET MONO STATUS")

    this.selectVariant(this._getVariantFromOptions()?.id);

    if (!document.querySelector("monogram-component").querySelector("#inputsContainer").hidden && document.querySelector(".atc-wl-container button").innerText != "Sold Out") {
      document.querySelector(".atc-wl-container button").disabled = !document.querySelector("monogram-component").ready
    }

  }
  _onMasterSelectorChanged() {

    const options = this.selectedVariant?.options || [];
    options.forEach((value, index) => {
      let input = this.optionSelectors[index].querySelector(
          `input[type="radio"][name="option${index + 1}"][value="${CSS.escape(
            value
          )}"], input[type="hidden"][name="option${
            index + 1
          }"], select[name="option${index + 1}"]`
        ),
        triggerChangeEvent = false;
      if (
        input.tagName === "SELECT" ||
        (input.tagName === "INPUT" && input.type === "hidden")
      ) {
        triggerChangeEvent = input.value !== value;
        input.value = value;
      } else if (input.tagName === "INPUT" && input.type === "radio") {
        triggerChangeEvent = !input.checked && input.value === value;
        input.checked = input.value === value;
      }

    let noSelect = document.querySelectorAll(".product-info__variant-picker .no-select") 
    if (noSelect.length > 0) {
      return
    }

      if (triggerChangeEvent) {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
  /**
   * Get the product variant by its ID
   */
  _getVariantById(id) {
    return this.product["variants"].find((variant) => variant["id"] === id);
  }
  /**
   * Get the variant based on the options
   */
  _getVariantFromOptions() {
    const options = this._getSelectedOptionValues();
    return this.product["variants"].find((variant) => {
      return variant["options"].every(
        (value, index) => value === options[index]
      );
    });
  }
  /**
   * Detect if a specific variant is selectable. This is used when the "hide sold out variant" option is enabled, to allow
   * returning true only if the variant is actually available
   */
  _isVariantSelectable(variant) {
    if (!variant) {
      return false;
    } else {
      return (
        variant["available"] ||
        (!this.hideSoldOutVariants && !variant["available"])
      );
    }
  }
  /**
   * This method is used internally to select an available or selectable variant, when the current choice does not
   * match the requirements. For instance, if sold out variants are configured to be hidden, but that the choices end
   * up being a non-valid variant, the theme automatically changes the variant to match the requirements. In the case
   * the customer end up on variant combinations that do not exist, it also switches to a valid combination.
   *
   * The algorithm is as follows: if we have for instance three options "Color", "Size" and "Material", we pop the last
   * option (Material) and try to find the first available variant for the given Color and Size. If none is found we
   * remove the second option (Size) and try to find the first available variant for the selected color. Finally, if none
   * is found we return the first available variant independently of any choice.
   */
  _getFirstMatchingAvailableOrSelectableVariant() {
    let options = this._getSelectedOptionValues(),
      matchedVariant = null,
      slicedCount = 0;
    do {
      options.pop();
      slicedCount += 1;
      matchedVariant = this.product["variants"].find((variant) => {
        if (this.hideSoldOutVariants) {
          return (
            variant["available"] &&
            variant["options"]
              .slice(0, variant["options"].length - slicedCount)
              .every((value, index) => value === options[index])
          );
        } else {
          return variant["options"]
            .slice(0, variant["options"].length - slicedCount)
            .every((value, index) => value === options[index]);
        }
      });
    } while (!matchedVariant && options.length > 0);

    return matchedVariant;
  }
  _getSelectedOptionValues() {
    return this.optionSelectors.map((optionSelector) => {
      return optionSelector.querySelector(
        'input[name^="option"][type="hidden"], input[name^="option"]:checked, select[name^="option"]'
      ).value;
    });
  }
  /**
   * We add specific class to sold out variants based on the selectors
   */
  _updateDisableSelectors() {
    const selectedVariant = this.selectedVariant;
    if (!selectedVariant) {
      return;
    }
    this._updateDisableSelectorsForOptionLevel(0, selectedVariant);
  }
  _updateDisableSelectorsForOptionLevel(level, selectedVariant) {
    if (!this.optionSelectors[level]) {
      return;
    }
    const applyClassToSelector = (
      selector,
      valueIndex,
      available,
      hasAtLeastOneCombination
    ) => {
      const optionValue = Array.from(
        selector.querySelectorAll("[data-option-value]")
      )[valueIndex];
      optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
      if (this.hideSoldOutVariants) {
        optionValue.toggleAttribute("hidden", !available);
      } else {
        optionValue.classList.toggle("is-disabled", !available);
      }
    };
    const hasCombination = (variant, level2, value, selectedVariant2) => {
      return Array.from({ length: level2 + 1 }, (_, i) => {
        if (i === level2) {
          return variant[`option${level2 + 1}`] === value;
        } else {
          return (
            variant[`option${i + 1}`] === selectedVariant2[`option${i + 1}`]
          );
        }
      }).every((condition) => condition);
    };
    this.product["options"][level]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = this.product["variants"].some(
        (variant) =>
          hasCombination(variant, level, value, selectedVariant) && variant
      );
      const hasAvailableVariant = this.product["variants"].some(
        (variant) =>
          hasCombination(variant, level, value, selectedVariant) &&
          variant["available"]
      );
      applyClassToSelector(
        this.optionSelectors[level],
        valueIndex,
        hasAvailableVariant,
        hasAtLeastOneCombination
      );
      this._updateDisableSelectorsForOptionLevel(level + 1, selectedVariant);
    });
  }
};
var VariantOptionValue = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener
    );
  }
  _onVariantChanged(event) {
    
    let select = this.closest("fieldset").querySelector("button.select span")

    if (select) {
      select.innerText = event.detail.variant[this.getAttribute("for")]
    }
    
    this.innerHTML = event.detail.variant[this.getAttribute("for")];
  }
};
if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}
if (!window.customElements.get("variant-option-value")) {
  window.customElements.define("variant-option-value", VariantOptionValue);
}